
import {
  Link,
  Element
} from "react-scroll";
import { images } from "./Images";
import { useMediaQuery } from "react-responsive";
import CommonButton from "./CommonButton";
import { MdArrowCircleDown } from 'react-icons/md';
import { useEffect } from "react";
import CampsItem from "./CampsItem";
import CampsDate from "./CampsDate";
import CampsImage from "./CampsImage";
import PageHeader from "./PageHeader";
import Underline from "./Underline";
import PensionBox from "./PensionBox";
import UnderlineSmall from "./UnderlineSmall";
import { FaFilePdf } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export default function Birthday() {

  const lg = useMediaQuery({ query: '(max-width: 1024px)' });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  useEffect(() => {
    const inViewport = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry: IntersectionObserverEntry) => {
        entry.target.classList.toggle("is-inViewport", entry.isIntersecting);
      });
    };

    const observer = new IntersectionObserver(inViewport);
    const element = document.querySelectorAll('[data-inviewport]');
    element.forEach(e => observer.observe(e));
  }, []);

  return <>
    <div className="flex flex-col">
      <PageHeader
        title={<>Fêtes d’enfants à l’écurie!</>}
        subtitle={<>Offrez à votre enfant une fête inoubliable dans un univers 100 % équestre!</>}
      />
      <Element name="section-01" className="w-screen min-h-screen bg-stone-700 text-stone-300 relative snap-start p-4 flex flex-row ">
        <div className="w-full portrait:w-4"></div>
        <div className="flex flex-col grow mt-2 lg:mt-8 landscape:max-w-6xl">
          <div className="text-3xl lg:text-6xl font-extrabold">Fêtes d’enfants à l’écurie Chevalex</div>
          <div className="text-md lg:text-2xl font-light pt-2">Semaines de pur bonheur à l'écurie pour les enfants</div>
          <Underline />
          <div className="flex flex-col grow r h-full mb-20">
            <p className="text-lg font-light">
              Offrez à votre enfant une fête différente, active et enrichissante!
              Nous vous proposons une expérience équestre unique de 3 heures, encadrée par deux instructeurs passionnés.

            </p>
            <p className="text-lg font-light mt-5 min-w-[40vw]">
              Les enfants et les parents pourront prendre soin des chevaux ainsi qu'être initiés à l'équitation avec une séance en selle.</p>

            <h4 className="mt-12 text-2xl  decoration-amber-600">Ce qui est inclus :</h4>
            <UnderlineSmall />
            <div className="flex flex-col items-start">
              <CampsItem icon={<>🐎</>} text={<>1h30 d’activités équestres avec 2 chevaux et 2 instructeurs</>} />
              <CampsItem icon={<>🎈</>} text={<>1h30 sous notre chapiteau décoré sur le thème cowboy, avec tables et chaises</>} />
              <CampsItem icon={<>🎁</>} text={<>Chaque enfant reçoit un sac surprise!</>} />
            </div>
            <h4 className="mt-12 text-2xl  decoration-amber-600">Autres informations :</h4>
            <UnderlineSmall />
            <div className="flex flex-col items-start">
              <CampsItem icon={<>🍰</>} text={<>Apportez votre gâteau et vos cadeaux, nous nous occupons du reste!</>} />
              <CampsItem icon={<>💰</>} text={<>Prix : 325 $ + taxes</>} />
              <CampsItem icon={<>✨</>} text={<>Option supplémentaire : ajoutez 1 cheval et 1 instructeur durant les 1h30 d’activités pour 100 $ + taxes</>} />
            </div>
            <p className="mt-10 mb-5 italic font-light">📅 Réservez dès maintenant pour offrir à votre enfant une fête mémorable, amusante et 100 % western!</p>
            <a href="mailto:info@ecuriechevalex.com" className="mb-2 ">
              <div className="flex flex-row "><MdEmail className=" text-white" />
                <span className=" ml-2 text-white">info@ecuriechevalex.com</span>
              </div>
            </a>
          </div>
        </div>
        <div className="w-full portrait:w-4"></div>


      </Element>
      
    </div>
  </>
}
